import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CustomAvatar from "components/common/Avatar";
import AppMenu, { MenuItem as AppMenuItem } from "components/common/Menu";
import { getPlgProfile } from "plg/auth/plgTokenStore";
import { logoutPlg } from "plg/api/plgAuth";
import { HIRE_ROUTES } from "plg/routes";
import { PLG_FEATURES } from "plg/features";
import { PLG_SIGNUP_ROUTE } from "constants/routes";

function PlgAccountMenu() {
  const navigate = useNavigate();
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const profile = getPlgProfile();
  const name = [profile?.firstName, profile?.lastName].filter(Boolean).join(" ") || profile?.companyName || "";

  return (
    <div className="navbar-actions flex items-center">
      <div className="user-menu-container" ref={anchorRef}>
        <div className={`user-menu-trigger flex items-center cursor-pointer py-05 ${open ? "menu-open" : ""}`} onClick={() => setOpen((v) => !v)}>
          <div className="user-avatar">
            <CustomAvatar size="md" />
          </div>
          <ArrowDropDownIcon className="dropdown-icon" />
        </div>
        {open && (
          <AppMenu open={open} onClose={() => setOpen(false)} anchorEl={anchorRef.current} minWidth="280px" autoWidth
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
            <div className="flex items-center p-075 gap-1">
              <CustomAvatar size="lg" />
              <div className="user-info">
                <p className="heading-h5-regular">{name}</p>
                <p className="user-email heading-h5-regular">{profile?.email || ""}</p>
              </div>
            </div>
            <div className="divider-bottom" />
            {PLG_FEATURES.companyPage && (
              <>
                {/* @ts-ignore — JS component */}
                <AppMenuItem value="Company" onClick={() => { setOpen(false); navigate(HIRE_ROUTES.company); }} />
                <div className="divider-bottom" />
              </>
            )}
            {/* @ts-ignore — JS component */}
            <AppMenuItem
              value="Logout"
              onClick={async () => {
                setOpen(false);
                await logoutPlg();
                navigate(PLG_SIGNUP_ROUTE, { replace: true });
              }}
            />
          </AppMenu>
        )}
      </div>
    </div>
  );
}

export default PlgAccountMenu;
